import { applyAuthTokenInterceptor, clearAuthTokens } from 'axios-jwt';
import axios from 'axios';
import CONSTANT from './constant';
import { message } from 'antd';

// Create an axios instance that you wish to apply the interceptor to
const axiosInstance = axios.create();
axiosInstance.defaults.headers.common['X-TK'] = CONSTANT.API.KEY;

// Define token refresh function
const requestRefresh = (refresh) => {
    // get current user
    let rawUser = localStorage.getItem(CONSTANT.STORAGE_KEY_USER);
    if (!rawUser) {
        clearAuthTokens();
        window.location.href = `/login?back=${window.location.pathname}`;
    }
    rawUser = JSON.parse(rawUser);
    return axios.post(`${CONSTANT.BASE_API}auth/refresh-token`,
        {
            refreshToken: refresh,
            email: rawUser.email,
            role: rawUser.role
        },
        {
            headers: {
                'X-TK': CONSTANT.API.KEY
            },
            validateStatus: function (status) {
                return status < 500; // Resolve only if the status code is less than 500
            }
        }
    )
        .then(res => {
            if (res && res.data && res.data.code === 200) {
                return res.data.data.token
            }
            else {
                clearAuthTokens();
                window.location.href = `/login?back=${window.location.pathname}`;
            }

        })
}

// Apply interceptor
applyAuthTokenInterceptor(axiosInstance, {
    requestRefresh,
    header: "Authorization",
    headerPrefix: "Bearer "
});

export {
    axiosInstance
}



// =============== Instance API SHOP =================================
const shopInstance = axios.create({
    baseURL: CONSTANT.SHOP_API,
    timeout: 800000,
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true,
});
// Interceptor Request
shopInstance.interceptors.request.use(
    async (config) => {
        // Check if user is authenticated and add user info to headers
        config.headers["X-TK"] = CONSTANT.SHOP_API_KEY;

        // Note: Authentication is handled via HttpOnly cookies automatically
        // The browser will send the cookie with each request if withCredentials: true is set

        return config;
    }, (error) => Promise.reject(error)
);

// Them interceptor de xu ly loi 401 (token het han)
shopInstance.interceptors.response.use(response => {
    return response.data;
}, async error => {
    if (error.response?.status === 401 || error?.response?.status === 503) {
        // Token expired or invalid, try to login again
        localStorage.removeItem(CONSTANT.STORAGE_KEY_USER);
        localStorage.removeItem('tatinta-agency');
        localStorage.removeItem('tatinta-agency-type');
        console.log('Shop token hết hạn hoặc không hợp lệ, thực hiện đăng nhập lại...');
        if (typeof window !== 'undefined') {
            // Clear auth store state
            try {
                console.log('Calling logout API...');
                await shopInstance.post(`${CONSTANT.SHOP_API}users/logout`);
                console.log('Logout API successful');
                message.error('Phiên đã hết hạn vui lòng đăng nhập lại để tiếp tục !', 2);
                window.location.href = '/login';
            } catch (apiError) {
                console.warn('Logout API call failed:', apiError);
                // Continue with local cleanup even if API fails
            }

        }
    }

    return Promise.reject(error);
});

// Ham dang nhap va lay lai token moi cho shop
export const loginAndGetTokenShop = async (username, password) => {
    try {
        // Login to shop API using current user credentials
        const res = await axios.post(`${CONSTANT.SHOP_API}users/login`, {
            username: username,
            password: password,
            role: 'agency'
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-TK': CONSTANT.API.KEY
            },
            withCredentials: true
        });
        if (res && res.data && res.status === 200) {
            console.log('Đăng nhập shop thành công');
            return res.data?.data
        } else {
            console.error('Đăng nhập shop thất bại:', res.data?.message);
            return null;
        }
    } catch (error) {
        console.error('Lỗi khi đăng nhập shop:', error.response?.data || error.message);
        return null;
    }
};

// Auto login to shop when user logs in to main system
export const autoLoginShop = async (username, password) => {
    try {
        console.log('Tự động đăng nhập shop...');
        await loginAndGetTokenShop(username, password);
    } catch (error) {
        console.error('Lỗi tự động đăng nhập shop:', error);
    }
};

export { shopInstance }